const menuReducer = (state = false, actions) => {
    switch (actions.type) {
        case 'TOGGLER':
            return !state;
        default:
            return state;
    }
}

export default menuReducer;